import { FC } from 'react';

import { IconProps } from '.';

export const JpgFileIcon: FC<IconProps> = ({ width = 32, height = 32 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 3.334v25.333a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V8.242a1 1 0 0 0-.264-.677l-5.439-5.909a1 1 0 0 0-.736-.322H7.5a2 2 0 0 0-2 2"
      fill="#5994D5"
      fillOpacity=".5"
    />
    <path
      d="M27 18.61H4v8.657a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V19.61a1 1 0 0 0-1-1"
      fill="#1C67B9"
    />
    <path d="M5.5 17 4 18.61h1.5z" fill="#11447C" />
    <path
      d="M11.654 20.91h.915v3.58q-.003.491-.209.847-.206.353-.576.544a1.85 1.85 0 0 1-.858.19q-.447 0-.806-.16a1.3 1.3 0 0 1-.564-.477q-.209-.316-.209-.786h.918a.7.7 0 0 0 .09.356q.088.15.245.228.158.08.36.08.222 0 .376-.092a.6.6 0 0 0 .234-.278q.082-.185.084-.453zM13.57 26v-5.09h1.91q.586 0 .984.218.4.22.604.602.207.38.206.865 0 .489-.206.87-.206.38-.609.6-.403.215-.992.215h-1.265v-.758h1.14q.345 0 .563-.12a.75.75 0 0 0 .323-.327q.107-.21.107-.48t-.107-.477a.73.73 0 0 0-.326-.321 1.2 1.2 0 0 0-.564-.117h-.845V26zm7.916-3.465a1.3 1.3 0 0 0-.172-.36 1.1 1.1 0 0 0-.258-.276 1 1 0 0 0-.343-.172 1.4 1.4 0 0 0-.423-.06 1.3 1.3 0 0 0-.73.207q-.321.207-.505.607-.182.397-.182.97 0 .576.182.976.18.4.504.609.324.206.751.206.388 0 .671-.149.285-.15.44-.422.154-.276.154-.647l.21.033H20.4v-.721h2.066v.611q0 .654-.279 1.131-.277.477-.765.736a2.4 2.4 0 0 1-1.119.256q-.703 0-1.235-.316a2.2 2.2 0 0 1-.828-.902q-.296-.587-.296-1.392 0-.617.174-1.101.177-.485.492-.823.316-.341.741-.517.426-.18.925-.179.422 0 .788.124.365.123.649.348.285.226.47.537.183.31.24.686zM12.111 17q-.458 0-.792-.32a1.1 1.1 0 0 1-.319-.79V8.11q0-.458.32-.778.332-.332.79-.332h7.778q.458 0 .778.333.333.32.333.778v7.778q0 .458-.333.792-.32.318-.778.319zm0-1.111h7.778V8.11H12.11zm.556-1.111h6.666L17.25 12l-1.667 2.222-1.25-1.666zm-.556 1.11V8.112z"
      fill="#fff"
    />
  </svg>
);
